<template>
    <div class="ExFormat">


		<h4>Формат formatId: {{ format_id }}</h4>

		<card
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">

			<el-table :data="ApiData" style="width: 100%;" ref="ApiData">
				<el-table-column
					label="ID"
					property="id"
					width="80"
					sortable
				>
				</el-table-column>
				<el-table-column 
					width="80"
					label="Порядок"
					property="sortOrder"
				>
				</el-table-column>
				<el-table-column 
					min-width="220"
					label="Название"
					property="name"
					sortable
				>
				</el-table-column>
				<el-table-column 
					min-width="220"
					label="Условия"
					property="filter"
				><template v-slot="scope">
						<ReObjFilter v-model="scope.row.filter" :readonly="true" :innerStyles="false"/>
					</template>
				</el-table-column>
				<el-table-column 
					min-width="220"
					label="Редактирование"
					property="id"
				>
					<template v-slot="scope">
						<base-button type="success" simple @click="goToRuleEdit(scope.row.id)">Изменить</base-button>
					</template>
				</el-table-column>
			</el-table>
			<base-button type="success" simple @click="addRule()">Добавить</base-button>
		</card>
		<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(10)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>
    </div>
</template>
<script>

/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/


import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { Collapse, CollapseItem } from 'src/components';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';

import Pagination from 'src/our_components/RePagination';
import ReObjFilter from '../our_components/ReObjFilter.vue';

export default {
	name: 'ex-format-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// Collapse, 
		// CollapseItem,
		// ReFilterBtn,
        // ReFilter,
		Pagination,
		ReObjFilter,
	},
	data() {
		return {
			ApiData: [],
			// masAllFilterParams: this.currentFilterConfig(),
			objGetParams:{},
			// bShowFilter: false,
			masObjects_total: 0,
			count2page: 10,
		};
	},
	computed:{
		format_id(){
			return this.$route.params.format_id;
		}
	},
	methods: {
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}

			if(this.format_id){
				this.$GVO.ApiCall('exportEditor.rules_GET',{flt:{formatId:this.format_id, ...filter}})
				.then((objApi) => {
					if(objApi.success === true){
						this.masObjects_total = 0;
						// console.log('exportEditor.rules_GET', objApi);
						if(objApi.data.length > 0){
							this.ApiData = objApi.data;
							if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
						}
					} else {
						this.ApiData = [];
						this.masObjects_total=0;
					}
				}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
			}
		},
		addRule(){
			this.$GVO.showPrompt('Укажите название','').then(result=>{
				if(result.value>''){
					this.$GVO.ApiCall('exportEditor.rules_INS',{iData:{
						formatId:this.format_id,
						name: result.value,
						rules:'[]',
						sortOrder: this.ApiData.reduce((v,row)=>Math.max(v,row.sortOrder+1),0)
					}}).then((result)=>{
						if(result.success == true){
							this.goToRuleEdit(result.new_id);
						}
					});
				}
			});
		},
		goToRuleEdit(rule_id){
			// console.log('clicked on rule, the key is ', rule_id);
			this.$router.push({path: '/data/export/id/'+this.format_id+'/rules/'+rule_id});
		},
		OnFilterApply(data){
			// console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},	
		currentFilterConfig(){
			// this.$GVO.ApiCall('billing.GET_FILTER',{})
			// 	.then((objApi) => {
			// 		if(objApi.success){
			// 			this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
			// 			eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
			// 		}
			// 	})
			// 	.catch(errorObjApi => console.log(errorObjApi));
			// return [];
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			// this.getApiData();
			this.OnFilterApply();
		},
	},		
	mounted() {
		// this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style scoped>
.ExFormat >>> .card-collapse .card:not(.card-cinc) .card-header a {
    color: #01B0E0;
}

</style>
